/**
 * Created by slava on 3/5/19
 */

const StartEpisodeWindow = CleverappsWindow.extend({
    onWindowLoaded: function (episodeNo) {
        this.episodeNo = episodeNo;

        this._super({
            title: Messages.get(`StartEpisodeWindow.Title${this.episodeNo}`),
            name: "startepisodewindow",
            content: this.getContent(),
            closeButton: false,
            button: {
                width: cleverapps.styles.StartEpisodeWindow.button.width,
                height: cleverapps.styles.StartEpisodeWindow.button.height,
                text: Messages.get("OK"),
                onPressed: this.close.bind(this)
            }
        });
    },

    getPerson: function () {
        return "hero";
    },

    getContent: function () {
        const styles = cleverapps.styles.StartEpisodeWindow;

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get(`StartEpisodeWindow.Text${this.episodeNo}`), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);

        return text;
    }
});

cleverapps.styles.StartEpisodeWindow = {
    text: {
        width: 600
    },

    button: {
        width: 250,
        height: 100
    }
};
